import {apiClient} from 'common/util/api-client';
import {getReportUrl} from 'common/report/util';

export async function makeDownloadQuery(projectId, workspaceId, params): Promise<Blob> {
  // using apiClient.fetch because we're getting back a blob
  // eslint-disable-next-line local-rules/deprecated-member-access
  return apiClient
    .fetch(getReportUrl(`download/`, {projectId, workspaceId}), {
      body: JSON.stringify(params),
      method: `POST`,
    })
    .then((response) => response.blob());
}
